<template>
	<vxe-modal v-model="showFlag" title="数据详情查看" :before-hide-method="beforeHideMethod" show-zoom resize
						:destroy-on-close="true" fullscreen remember :esc-closable="true" :mask="false":lock-view="false">
			<a-layout  style="padding: 0;">
				<a-layout-sider   width="240" theme="light" class="mySider">
					<a-directory-tree multiple @select="onSelect" :selectedKeys="checkedMonitor"   :defaultSelectedKeys="checkedMonitor">
						<a-tree-node v-for="(item,index) in parentList" :key="item.value" :title="item.name" style="color: white;">
							<a-tree-node  v-for="(subItem,subIndex) in getSubTreeLeafNodeByParent(item.name,item.value)"
															:key="subItem.meterId"  :title="subItem.monitorName" is-leaf />
						</a-tree-node>
					</a-directory-tree>
				</a-layout-sider>
				<a-layout-content style="background-color: white;padding: 0.625rem;">
					<div class="actDiv">
						<label style="font-size: 0.8rem;">给水号：</label>
						<a-input style="width: 10.5rem;" v-model="theApid"  @change="apidChangeHandler"></a-input>
						<label style="font-size: 0.8rem;margin-left: 0.625rem;">时间区间：</label>
						<a-date-picker v-model="dateStart" style="margin-right: 0.5rem;width: 6rem;"
												show-time format="YYYY-MM-DD HH:mm:ss"/>
						<label>至</label>
						<a-date-picker   v-model="dateEnd"  style="margin-left: 0.5rem;width: 6rem;"
										show-time format="YYYY-MM-DD HH:mm:ss"/>
						
						<a-button size="small"   icon="search" @click="doQuery" style="margin: 0 0.5rem;" :loading="loading">查询</a-button>
						<a-button  size="small" :disabled="totalList.length==0"   @click="doExport"  icon="cloud-download" :loading="exportLoading">导出</a-button>
					</div>
					<vxe-table  size="small"   max-height="600" row-id="PID" :loading="loading" align="center"
								:data="statisList" border stripe :seq-config="{startIndex: (pageModel.currentPage - 1) * pageModel.pageSize}">
						<vxe-column type="seq" title="序号" width="60"></vxe-column>
						<vxe-column field="ActionResult" title="抄表读数" sortable></vxe-column>
						<vxe-column field="ActionTime" title="抄表时间" :formatter="getTimeFormatter" sortable></vxe-column>
					</vxe-table>
					 <vxe-pager :loading="loading"
								:current-page="pageModel.currentPage"
								:page-size="pageModel.pageSize"
								:total="pageModel.totalResult"
								:layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
					          @page-change="handlePageChange">
					</vxe-pager>
				</a-layout-content>
			</a-layout>
	</vxe-modal>
</template>

<script>
	export default {
		data() {
			return {
				showFlag: false,
				checkedMonitor:[],
				parentList:[],
				dataList:[],
				statisList:[],
				totalList:[],
				loading:false,
				theApid:"",
				exportLoading:false,
				dateStart:null,
				dateEnd:null,
				pageModel:{
					currentPage:1,
					pageSize:this.Config.PAGE_SIZE,
					totalResult:0,
				}
			}
		},
		methods: {
			beforeHideMethod(){
				this.checkedMonitor = [];
				this.clearData();
			},
			handlePageChange({ currentPage, pageSize }){
				this.pageModel.currentPage = currentPage;
				this.pageModel.pageSize = pageSize;
				this.createPageList();
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			showView() {
				this.showFlag = true;
			},
			getSubTreeLeafNodeByParent(parentName,parentKey){
				let temp = [];
				if(parentKey == 0){
					temp = this.Config.deepClone(this.dataList);
				}else{
					let a = parentName.split("(");
					for (var i = 0; i < this.dataList.length; i++) {
						let item =  this.dataList[i];
						if(item.groupName == a[0]){
							temp.push(item);
						}
					}
				}
				return temp;
			},
			createPageList(){
				if(this.totalList.length>0){
					this.pageModel.totalResult = this.totalList.length;
					let begin = this.Config.getListStart(this.pageModel.currentPage,this.pageModel.pageSize);
					let end = this.Config.getListEnd(this.pageModel.currentPage,this.pageModel.pageSize);
					this.statisList = this.totalList.slice(begin,end);
				}
			},
			createParentList(){
				let titleList = ["监控点"];
				this.dataList.forEach((item)=>{
					if(titleList.indexOf(item.groupName) ==-1){
						titleList.push(item.groupName);
					}
				});
				for (var i = 0; i < titleList.length; i++) {
					let name = titleList[i];
					let array = this.getSubTreeLeafNodeByParent(name,i);
					let title = name+"("+array.length+")";
					let item = {name:title,value:i};
					this.parentList.push(item);
				}
			},
			onSelect(keys, event){
				this.checkedMonitor = keys;
				let item = this.getTheCheckMonitor();
				if(item != null){
					this.theApid = item.meterApid;
				}
			},
			getTheCheckMonitor(){
				var result = null;
				let checkedMeter = this.checkedMonitor[0];
				for(var i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(checkedMeter == item.meterId){
						result = item;
						break;
					}
				}
				return  result;
			},
			clearData(){
				this.pageModel.currentPage = 1;
				this.totalList = [];
				this.statisList = [];
			},
			doQuery(){
				if(this.doValid()){
					this.loading = true;
					let url = this.Api.getLastUrl(this.Api.METER_MONITOR_QUERY_DETAIL_URL);
					let param = {
						meterId:this.checkedMonitor[0],
						beginTime:this.$moment(this.dateStart).format('YYYY-MM-DD HH:mm:ss'),
						endTime:this.$moment(this.dateEnd).format('YYYY-MM-DD HH:mm:ss'),
					};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.loading = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.clearData();
							this.totalList = result;
							this.createPageList();
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.loading = false;
						console.log(error);
					});
				}
			},
			apidChangeHandler(e){
				let v = e.target.value;
				if(v.length>=10){
					let a= this.getMarkerByApid(v);
					if(a!=null){
						let meterId = a.meterId;
						this.checkedMonitor=[meterId];
					}else{
						this.checkedMonitor=[];
					}
				}else{
					this.checkedMonitor=[];
				}
			},
			getMarkerByApid(apid){
				let result = null;	
				for(var i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(item.meterApid == apid){
						result = item;
						break;
					}
				}
				return result;
			},
			doValid(){
				if(!this.checkedMonitor.length){
					this.$message.error('监控点不能为空');
					return false;
				}
				if(!this.dateStart && !this.dateEnd){
					this.$message.error('请选择开始时间和截止时间');
					return false;
				}
				return true;
			},
			getMeterMonitorList4Map(){
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_MAP_INFO_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
						this.createParentList();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			doExport(){
				this.exportLoading = true;
				let param = {
					meterId:this.checkedMonitor[0],
					beginTime:this.$moment(this.dateStart).format('YYYY-MM-DD HH:mm:ss'),
					endTime:this.$moment(this.dateEnd).format('YYYY-MM-DD HH:mm:ss'),
				};
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_DATA_EXPORT_URL);
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = '监控点详情下载.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
		},
		created() {
			this.getMeterMonitorList4Map();
		},
	}
</script>

<style>
</style>
